import { useTranslation } from 'react-i18next';
import { VERSION } from '../../version';
import { SITE_URL } from '~/utils/config';

export function Metadata(props: {
  title?: string;
  description?: string;
  imageUrl?: string;
  lang?: string;
  alternates?: { lang: string; href: string }[];
  canonical?: string;
  keywords?: string;
}) {
  const { t } = useTranslation();
  const title = props.title ?? t('title', { titlePrefix: t('defaultTitlePrefix') });
  const description = props.description ?? t('description');
  const siteName = t('site_name');
  const url = props.canonical ?? SITE_URL;
  const keywords = props.keywords ?? t('meta_keywords');

  return (
    <>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta name="twitter:title" content={title} />

      <meta property="og:site_name" content={siteName} />

      <link rel="canonical" href={url} />
      {props.alternates?.map((alt) => (
        <link key={alt.lang} rel="alternate" href={alt.href} hrefLang={alt.lang} />
      ))}
      <meta property="og:url" content={url} />

      <meta property="og:description" content={description} />
      <meta name="description" content={description} />
      <meta name="twitter:description" content={description} />
      <meta name="keywords" content={keywords} />

      <meta name="version" content={VERSION} />

      {props.imageUrl && (
        <>
          <meta property="og:image" content={props.imageUrl} />
          <meta name="twitter:image" content={props.imageUrl} />
        </>
      )}
    </>
  );
}
